import { Agent } from "../types/Agent";
import { AgentSource } from "../types/AgentSource";

export function normalizeAdmitAgents(
  data: Record<string, any>[],
  baseUrl: string,
): Agent[] {
  return data.map((agent) => {
    return {
      id: agent.ExternalID ? `${agent.ExternalID}` : "",
      name: agent.Name,
      countryName: agent.AddressCountry,
      countryCode: agent.AddressCountry2,
      imageUrl: agent.LogoUrl,
      flagUrl: agent.AddressCountry2
        ? `${baseUrl}/images/flags/svg/${agent.AddressCountry2}.svg`
        : "",
      website: agent.Website,
      email: agent.Email,
      phone: agent.PhoneNumber,
      address: agent.Address,
      socialLinks: {
        whatsapp: agent.SocialLinks.whatsapp,
        wechat: agent.SocialLinks.wechat,
        weibo: agent.SocialLinks.weibo,
        linkedin: agent.SocialLinks.linkedin,
        line: agent.SocialLinks.line,
        twitter: agent.SocialLinks.twitter,
        facebook: agent.SocialLinks.facebook,
      },
    };
  });
}

export function normalizeCaptureAgents(
  data: Record<string, any>[],
  baseUrl: string,
): Agent[] {
  return data.map((agent) => {
    return {
      id: agent.id,
      name: agent.name,
      countryName: agent.country_name,
      countryCode: agent.country_code,
      imageUrl: agent.agency_logo ? agent.agency_logo : "",
      flagUrl: agent.country_code
        ? `${baseUrl}/static/assets/flags/${agent.country_code.toLowerCase()}.svg`
        : "",
      website: agent.web_site_url,
      email: agent.email,
      phone: agent.phone_number,
      address: agent.address,
      socialLinks: {
        whatsapp: agent.social_links.whatsapp,
        wechat: agent.social_links.wechat,
        weibo: agent.social_links.weibo,
        linkedin: agent.social_links.linkedin,
        line: agent.social_links.line,
        twitter: agent.social_links.twitter,
        facebook: agent.social_links.facebook,
      },
    };
  });
}

async function fetchAdmitAgents(
  baseUrl: string,
  institutionCodes: string[],
  search: string,
  country: string,
): Promise<Agent[]> {
  const url = new URL(
    `${baseUrl}/webservices/public/index.cfm/institution_agencies`,
  );
  if (institutionCodes.length) {
    url.searchParams.append("institutionCodes", institutionCodes.join(","));
  }
  if (search) {
    url.searchParams.append("term", search);
  }
  if (country) {
    url.searchParams.append("country", country);
  }
  url.searchParams.append("countryInSearch", "1");

  return fetch(url.toString())
    .then((response) => response.json())
    .then((data) => normalizeAdmitAgents(data, baseUrl));
}

async function fetchCaptureAgents(
  baseUrl: string,
  institutionCodes: string[],
  search: string,
  country: string,
): Promise<Agent[]> {
  const url = new URL(`${baseUrl}/api/agent_widget/v1/agents`);
  if (institutionCodes.length) {
    institutionCodes.forEach((code) => {
      url.searchParams.append("institutionCodes", code);
    });
  }
  if (search) {
    url.searchParams.append("term", search);
  }
  if (country) {
    url.searchParams.append("country", country);
  }
  url.searchParams.append("page_size", "0");
  return fetch(url.toString())
    .then((response) => response.json())
    .then((data) => normalizeCaptureAgents(data.items, baseUrl));
}

export function fetchAgents(
  source: AgentSource,
  baseUrl: string,
  institutionCodes: string[],
  search: string,
  country: string,
): Promise<Agent[]> {
  switch (source) {
    case "admit":
      return fetchAdmitAgents(baseUrl, institutionCodes, search, country);
    case "capture":
      return fetchCaptureAgents(baseUrl, institutionCodes, search, country);
  }
}
